module.exports = __webpack_public_path__ + "img/update-ai-button.7bb36c74.png";